










































import AbpBase from "@/lib/abpbase";
import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import { SavePathologyData } from "@/api/hd";
@Component({})
export default class extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop({ type: Object, default: {} }) data: any;
  form: any = {};
  Url = XMLHTTP_BASEURL;
  imageUrlList: any = [];
  created() {
    this.form = Object.assign({}, this.data);
    this.form.inspectionDate = this.formatDateTime(this.form.inspectionDate);
    if (this.form.mirrorUnder) {
      this.imageUrlList = this.form.mirrorUnder.split(";");
    }
  }
  rules = {};
  cancel() {
    (this.$refs.form as any).resetFields();
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
  }
  async save() {
    this.form.mirrorUnder = this.imageUrlList.join(";");
    (this.$refs.form as any).validate(async (valid: boolean) => {
      if (valid) {
        this.form.inspectionDate = this.formatDateTime(
          this.form.inspectionDate
        );
        let res = await SavePathologyData(this.form);
        if (res.status == 1) {
          this.$emit("input", false);
          this.$emit("on-success");
        }
      }
    });
  }
  handleSignSuccess(res: any, file: any) {
    let path = res.result.objects.imageAddress;
    this.imageUrlList.push(path);
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/pathologyManage/parts/pathologicdiagnosis/addOrEditPathology.vue